import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Briefcase, User, FileText, 
  Calendar as CalendarIcon, CreditCard, LogOut, LayoutDashboard 
} from 'lucide-react';
import './CandidateDashboard.css'; 

import CandidateProfile from './CandidateProfile';
import CandidateJobs from './CandidateJobs';
import CandidateResumes from './CandidateResumes';
import CandidateCalendar from './CandidateCalendar';
import Payments from './Payments'; 

const CandidateDashboard = () => {
  const [activeTab, setActiveTab] = useState('Jobs');
  const [candidateName, setCandidateName] = useState('');
  const [userId, setUserId] = useState(() => localStorage.getItem('userId')); 
  
  const [premiumCredits, setPremiumCredits] = useState(0);
  
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    const storedName = localStorage.getItem('candidateName');
    if (!storedUserId) {
        navigate('/candidate-login');
    } else {
        if (!userId) setUserId(storedUserId);
        if (storedName) setCandidateName(storedName);
    }
  }, [userId, navigate]);

  const handleLogout = () => {
    localStorage.clear();
    setUserId(null); 
    navigate('/');
  };

  const navItems = [
    { name: 'Jobs', icon: <Briefcase size={20} /> },
    { name: 'Profile', icon: <User size={20} /> },
    { name: 'Resumes', icon: <FileText size={20} /> },
    { name: 'Calendar', icon: <CalendarIcon size={20} /> },
    { name: 'Payments', icon: <CreditCard size={20} /> },
  ];

  const renderContent = () => {
    if (!userId) return <div className="loading-message">Loading user data...</div>;

    switch (activeTab) {
      // --- THE FIX: Passed onGoToPayments prop ---
      case 'Jobs': return <CandidateJobs userId={userId} setPremiumCredits={setPremiumCredits} onGoToPayments={() => setActiveTab('Payments')} />;
      case 'Profile': return <CandidateProfile />;
      case 'Resumes': return <CandidateResumes />;
      case 'Calendar': return <CandidateCalendar onSwitchToJobs={() => setActiveTab('Jobs')} />;
      case 'Payments': return <Payments userId={userId} />;
      default: return <CandidateJobs userId={userId} setPremiumCredits={setPremiumCredits} onGoToPayments={() => setActiveTab('Payments')} />;
    }
  };

  return (
    <div id="candidate-portal-wrapper">
      <aside className="portal-sidebar">
        <div className="sidebar-brand">
          <LayoutDashboard className="brand-icon" />
          <span>Candidate Portal</span>
        </div>

        <nav className="sidebar-menu">
          {navItems.map((item) => (
            <div 
              key={item.name}
              className={`menu-item ${activeTab === item.name ? 'active' : ''}`}
              onClick={() => setActiveTab(item.name)}
            >
              {item.icon}
              <span>{item.name}</span>
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <LogOut size={18} />
            <span>Log Out</span>
          </button>
        </div>
      </aside>

      <main className="portal-main">
        <header className="portal-topbar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 30px' }}>
          <h2 className="tab-title" style={{ margin: 0 }}>{activeTab}</h2>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
            
            {premiumCredits > 0 && (
              <div style={{ background: '#ecfdf5', border: '1px solid #10b981', color: '#059669', padding: '6px 14px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px' }}>
                ⭐ {premiumCredits} Premium Credits
              </div>
            )}

            <div className="user-profile-section" onClick={() => setActiveTab('Profile')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}>
               <div className="user-info" style={{ textAlign: 'right' }}>
                  <span className="user-name" style={{ display: 'block', fontWeight: 'bold', color: '#0f172a', fontSize: '0.95rem' }}>
                    {candidateName || 'Candidate'}
                  </span>
                  <span className="user-role" style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: premiumCredits > 0 ? '#10b981' : '#94a3b8' }}>
                    {premiumCredits > 0 ? 'Premium Member' : 'Free Account'}
                  </span>
               </div>
               <div className="avatar-circle" style={{ width: '42px', height: '42px', borderRadius: '50%', background: premiumCredits > 0 ? 'linear-gradient(135deg, #3b82f6, #1e3a8a)' : '#94a3b8', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '1.2rem' }}>
                  {candidateName ? candidateName.charAt(0).toUpperCase() : 'C'}
               </div>
            </div>

          </div>
        </header>

        <section className="portal-content-body">
            {renderContent()}
        </section>
      </main>
    </div>
  );
};

export default CandidateDashboard;